import { ERoomType } from 'shared/types/offers';
import { sendAnalytics } from 'shared/utils/analytics';

const ROOM_TYPE_ANALYTICS_MAP: Partial<Record<ERoomType, string>> = {
  [ERoomType.FlatOneRoom]: 'one',
  [ERoomType.FlatTwoRooms]: 'two',
  [ERoomType.FlatThreeRooms]: 'three',
  [ERoomType.FlatFourRooms]: 'four',
};

interface ITrackRoomTypeFilterChangeParams {
  roomType: ERoomType | 'all';
  count: number;
}

export const trackRoomTypeFilterChange = ({ roomType, count }: ITrackRoomTypeFilterChangeParams) => {
  sendAnalytics({
    action: 'Click',
    label: `rooms_count/${count}`,
    page: {
      extra: {
        roomscount: getRoomsCount(roomType),
        flattype: getFlatType(roomType),
      },
    },
  });
};

function getRoomsCount(value: ERoomType | 'all') {
  return ['all', ERoomType.Studio, ERoomType.FlatFreeLayout].includes(value)
    ? null
    : ROOM_TYPE_ANALYTICS_MAP[value as ERoomType];
}

function getFlatType(value: ERoomType | 'all') {
  switch (value) {
    case 'all':
      return null;
    case ERoomType.Studio:
      return 'studio';
    case ERoomType.FlatFreeLayout:
      return 'openPlan';
    default:
      return 'rooms';
  }
}
